const textColors = {
  primary: "text-primary",
  //
  white: "text-white",
  black: "text-black",
  //
  red: "text-red-400",
  red_500: "text-red-500",
  red_600: "text-red-600",
  red_700: "text-red-700",
  //
  green: "text-green-400",
  green_500: "text-green-500",
  green_600: "text-green-600",
  green_700: "text-green-700",
  //
  yellow: "text-yellow-400",
  yellow_500: "text-yellow-500",
  yellow_600: "text-yellow-600",
  yellow_700: "text-yellow-700",
  //
  blue: "text-blue-400",
  blue_500: "text-blue-500",
  blue_600: "text-blue-600",
  blue_700: "text-blue-700",
  //
  gray_100: "text-gray-100",
  gray_200: "text-gray-200",
  gray_300: "text-gray-300",
  gray_400: "text-gray-400",
  gray_500: "text-gray-500",
  gray_600: "text-gray-600",
  gray_700: "text-gray-700",
};

const bgColors = {
  primary: "bg-primary",
  brandyellow: 'bg-brandyellow',
  //
  white: "bg-white",
  black: "bg-black",
  //
  red: "bg-red-400",
  red_500: "bg-red-500",
  red_600: "bg-red-600",
  red_700: "bg-red-700",
  //
  green: "bg-green-400",
  green_500: "bg-green-500",
  green_600: "bg-green-600",
  green_700: "bg-green-700",
  //
  yellow: "bg-yellow-400",
  yellow_500: "bg-yellow-500",
  yellow_600: "bg-yellow-600",
  yellow_700: "bg-yellow-700",
  //
  blue: "bg-blue-400",
  blue_500: "bg-blue-500",
  blue_600: "bg-blue-600",
  blue_700: "bg-blue-700",
  //
  gray: "bg-gray-300",
  gray_100: "bg-gray-100",
  gray_200: "bg-gray-200",
  gray_300: "bg-gray-300",
  gray_400: "bg-gray-400",
  gray_500: "bg-gray-500",
  gray_600: "bg-gray-600",
  gray_700: "bg-gray-700",
};

const tokens = { textColors, bgColors };

export default tokens;